export default {
  // 预警状态
  state: {
    0: '预警中',
    1: '已完结',
  },

  // 风险等级
  level: {
    0: '无风险',
    1: '低风险',
    2: '中风险',
    3: '高风险',
    4: '高危风险',
  },
  // 风控用到的订单状态
  orderState: {
    2500: '履约中',
    3500: '退车待验车',
    4500: '订单待核算',
    5000: '费用待结算',
    5500: '已关闭',
  },
  // 不同风险等级对应的tag类型
  bgColor: {
    0: 'info',
    1: 'success',
    2: 'warning',
    3: 'danger',
    4: 'danger',
  },
}
